import React, { useState } from 'react';
import './Registration.css';
import { auth, googleProvider, facebookProvider, createUserWithEmailAndPassword, signInWithPopup } from './firebase';
import { useNavigate, useLocation } from 'react-router-dom';
import { addDocument, getDocument } from './firestore';

const Registration = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = location.state?.from?.pathname || '/';

  // Handle form submission for email/password registration
  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      await addDocument('users', userCredential.user.uid, {
        email: userCredential.user.email,
        games: 0,
        score: 0,
        streak: 1,
        streak_updated: userCredential.user.metadata.creationTime,
        question_answered: 0,
        question_correct: 0,
        firstName: firstName,
        lastName: lastName,
        created_at: userCredential.user.metadata.creationTime
      });

      // for storing the gameplay data total
      const userId = auth.currentUser.uid;
      const subCollectionPath = `gameplay`;
    
     const gameplayData = {
      firstName: firstName,
        lastName: lastName,
        total_questions: 0,
        questions_answered: 0,
        score: 0,
        games_played: 0
      };
      await addDocument(subCollectionPath, userId, gameplayData);
      console.log('User registered and profile updated:', userCredential.user);
      navigate(redirectTo);
    } catch (error) {
      setError(error.message);
    }
  };

  // Helper function to save user data to Firestore
  const saveUserToFirestore = async (user, additionalData = {}) => {
  try {
    const userDoc = await getDocument('users', user.uid);
    const gameplayDoc = await getDocument('gameplay', user.uid);

    if (!userDoc?.exists()) {
      await addDocument('users', user.uid, {
        email: user.email,
        games: 0,
        score: 0,
        streak: 1,
        question_answered: 0,
        question_correct: 0,
        firstName: additionalData.firstName || user.displayName?.split(' ')[0] || 'First',
        lastName: additionalData.lastName || user.displayName?.split(' ')[1] || 'Last',
        created_at: user.metadata.creationTime,
      });
      console.log('New user added to Firestore:', user);
    }

    if (!gameplayDoc?.exists()) {
      await addDocument('gameplay', user.uid, {
        firstName: additionalData.firstName || user.displayName?.split(' ')[0] || 'First',
        lastName: additionalData.lastName || user.displayName?.split(' ')[1] || 'Last',
        total_questions: 0,
        questions_answered: 0,
        score: 0,
        games_played: 0
      });
      console.log('Gameplay data initialized for new user');
    }
  } catch (error) {
    console.error("Error checking or adding user/gameplay data to Firestore:", error);
  }
};


  // Handle Google sign-up
  const handleGoogleSignup = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      await saveUserToFirestore(result.user);
      console.log('User signed up with Google:', result.user);
      navigate(redirectTo);
    } catch (error) {
      setError(error.message);
    }
  };

  // Handle Facebook sign-up
  const handleFacebookSignup = async () => {
    try {
      const result = await signInWithPopup(auth, facebookProvider);
      await saveUserToFirestore(result.user);
      console.log('User signed up with Facebook:', result.user);
      navigate(redirectTo);
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="registration-page">
      <div className="container">
        <div className="left-side">
          <h1>QUIZ ARCADE</h1>
          <p>QUIZ WHILE YOU PLAY – ARE YOU READY FOR THE ARCADE?</p>
          <img src="controller.png" alt="Gaming Controller" className="controller-img" />
        </div>

        <div className="right-side">
          <h2>Create Account</h2>
          {error && <p className="error-message">{error}</p>}
          <form onSubmit={handleRegister}>
            <div className="form-group">
              <input type="text" name="first_name" placeholder="First Name" value={firstName}
                onChange={(e) => setFirstName(e.target.value)} required />
              <input type="text" name="last_name" placeholder="Last Name" value={lastName}
                onChange={(e) => setLastName(e.target.value)} required />
            </div>
            <div className="form-group">
              <input type="email" name="email" placeholder="Email Address" value={email}
                onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="form-group">
              <input type="password" name="password" placeholder="Password" value={password}
                onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <button type="submit" className="create-account-btn">Create Account</button>
            <p>Already have an account? <a href="/login">Login</a></p>

            <div className="social-signup">
              <button type="button" className="google-signup" onClick={handleGoogleSignup}>
                <img src="gmail.png" alt="Gmail Icon" className="icon" /> Sign up with Gmail
              </button>
              <button type="button" className="facebook-signup" onClick={handleFacebookSignup}>
                <img src="fb.png" alt="Facebook Icon" className="icon" /> Sign up with Facebook
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Registration;
